import axios from 'src/utils/axios';
import helpers from 'src/helpers';
import { NOTIFICATION_STATUS } from 'src/constants';
import { addNotification } from 'src/actions/notificationActions';
import { describeEventLinkOutcomeText } from 'src/views/pages/ShareCenterView/LinkYourEventsStep/eventChoices';

// Action Types
export const GET_SMART_LINKS = '@smart-links/get-smart-links';
export const GET_SMART_LINKS_SUCCESS = '@smart-links/get-smart-links-success';
export const GET_SMART_LINKS_ERROR = '@smart-links/get-smart-links-error';
export const CLEAR_SMART_LINKS = '@smart-links/clear-smart-links';

export const GET_SMART_LINK = '@smart-links/get-smart-link';
export const GET_SMART_LINK_SUCCESS = '@smart-links/get-smart-link-success';
export const GET_SMART_LINK_ERROR = '@smart-links/get-smart-link-error';
export const CLEAR_SMART_LINK = '@smart-links/clear-smart-link';

export const CREATE_SMART_LINK = '@smart-links/create-smart-link';
export const CREATE_SMART_LINK_SUCCESS = '@smart-links/create-smart-link-success';
export const CREATE_SMART_LINK_ERROR = '@smart-links/create-smart-link-error';

export const UPDATE_SMART_LINK = '@smart-links/update-smart-link';
export const UPDATE_SMART_LINK_SUCCESS = '@smart-links/update-smart-link-success';
export const UPDATE_SMART_LINK_ERROR = '@smart-links/update-smart-link-error';

export const DELETE_SMART_LINK = '@smart-links/delete-smart-link';
export const DELETE_SMART_LINK_SUCCESS = '@smart-links/delete-smart-link-success';
export const DELETE_SMART_LINK_ERROR = '@smart-links/delete-smart-link-error';
export const CLEAR_SMART_LINK_WAS_DELETED = '@smart-links/clear-smart-link-was-deleted';

export const DUPLICATE_SMART_LINK = '@smart-links/duplicate-smart-link';
export const DUPLICATE_SMART_LINK_SUCCESS = '@smart-links/duplicate-smart-link-success';
export const DUPLICATE_SMART_LINK_ERROR = '@smart-links/duplicate-smart-link-error';

export const VERIFY_SMART_LINK_SHARE_CODE = '@smart-links/verify-share-code';
export const VERIFY_SMART_LINK_SHARE_CODE_SUCCESS = '@smart-links/verify-share-code-success';
export const VERIFY_SMART_LINK_SHARE_CODE_ERROR = '@smart-links/verify-share-code-error';

export const APPLY_SMART_LINK_SHARE_CODE = '@smart-links/apply-share-code';
export const APPLY_SMART_LINK_SHARE_CODE_SUCCESS = '@smart-links/apply-share-code-success';
export const APPLY_SMART_LINK_SHARE_CODE_ERROR = '@smart-links/apply-share-code-error';

export const GET_SMART_LINK_CLICKS = '@smart-links/get-smart-link-clicks';
export const GET_SMART_LINK_CLICKS_SUCCESS = '@smart-links/get-smart-link-clicks-success';
export const GET_SMART_LINK_CLICKS_ERROR = '@smart-links/get-smart-link-clicks-error';
export const CLEAR_SMART_LINK_CLICKS = '@smart-links/clear-smart-link-clicks';

export const GET_ACTIVE_SMART_LINKS = '@smart-links/get-active-smart-links';
export const GET_ACTIVE_SMART_LINKS_SUCCESS = '@smart-links/get-active-smart-links-success';
export const GET_ACTIVE_SMART_LINKS_ERROR = '@smart-links/get-active-smart-links-error';
export const CLEAR_ACTIVE_SMART_LINKS = '@smart-links/clear-active-smart-links';

export const SET_SMART_LINKS_QUERY = '@smart-links/set-query';
export const CLEAR_SMART_LINKS_QUERY_FILTER = '@smart-links/clear-query-filter';
export const SET_BACK_TO_SMART_LINKS_LIST = '@smart-links/set-back-to-list';
export const SET_BACK_TO_SMART_LINK_CLICK_HISTORY = '@smart-links/set-back-to-click-history';
export const SET_CURRENT_NAVIGATION_TAB = '@smart-links/set-current-navigation-tab';

// Action Creators

export const setCurrentNavigationTab = (tab) => ({
  type: SET_CURRENT_NAVIGATION_TAB,
  payload: tab,
});

export const setSmartLinksQuery = (query) => ({
  type: SET_SMART_LINKS_QUERY,
  payload: query
});

export const setBackToSmartLinksList = (payload) => ({
  type: SET_BACK_TO_SMART_LINKS_LIST,
  payload,
});

export const setBackToSmartLinkClickHistory = (payload) => ({
  type: SET_BACK_TO_SMART_LINK_CLICK_HISTORY,
  payload,
});

export const clearBackToSmartLinksList = (clearAll = false) => ({
  type: SET_BACK_TO_SMART_LINKS_LIST,
  payload: !clearAll ? {
    smartLinks: [],
    query: {},
  } : false,
});

export const clearSmartLinksQueryFilter = () => ({
  type: CLEAR_SMART_LINKS_QUERY_FILTER,
});

export const getSmartLinks = () => async (dispatch, getState) => {
  dispatch({
    type: GET_SMART_LINKS,
  });
  try {
    const query = getState()?.smartLinks?.query || {};
    const params = {};

    // Status filter
    if (query.status && query.status !== 'All') {
      params.status = query.status;
    }

    // Search filter
    if (query.search) {
      params.search = query.search;
    }

    // Sort params
    if (query.sort && query.sort.length > 0) {
      const [sortField, sortDirection] = query.sort[0];
      params.sortBy = sortField;
      params.sortOrder = sortDirection;
    }

    const response = await axios.get('/api/smart-links', { params });
    dispatch({
      type: GET_SMART_LINKS_SUCCESS,
      payload: response?.data?.smartLinks || [],
    });
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(
      GET_SMART_LINKS_ERROR,
      helpers.transform.toString(message || error || 'Server error'),
      NOTIFICATION_STATUS.ERROR
    ));
    dispatch({
      type: GET_SMART_LINKS_ERROR,
    });
  }
};

export const getSmartLink = (smartLinkId) => async (dispatch) => {
  dispatch({
    type: GET_SMART_LINK,
  });
  try {
    const response = await axios.get(`/api/smart-links/${smartLinkId}`);
    const smartLink = response?.data?.smartLink;

    if (smartLink) {
      dispatch({
        type: GET_SMART_LINK_SUCCESS,
        payload: smartLink,
      });
    } else {
      dispatch(addNotification(
        GET_SMART_LINK_ERROR,
        'Smart link not found',
        NOTIFICATION_STATUS.ERROR
      ));
      dispatch({
        type: GET_SMART_LINK_ERROR,
      });
    }
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(
      GET_SMART_LINK_ERROR,
      helpers.transform.toString(message || error || 'Server error'),
      NOTIFICATION_STATUS.ERROR
    ));
    dispatch({
      type: GET_SMART_LINK_ERROR,
    });
  }
};

export const createSmartLink = (
  payload,
  doWhenTry = false,
  doWhenCatch = false
) => async (dispatch) => {
  try {
    dispatch({
      type: CREATE_SMART_LINK,
    });
    const response = await axios.post('/api/smart-links', payload);
    const { smartLink } = response?.data || {};

    if (!smartLink?.id) {
      dispatch(addNotification(
        CREATE_SMART_LINK_ERROR,
        'Cannot create smart link',
        NOTIFICATION_STATUS.ERROR
      ));
      dispatch({
        type: CREATE_SMART_LINK_ERROR,
      });
      return;
    }

    dispatch(addNotification(
      CREATE_SMART_LINK_SUCCESS,
      `Smart link "${smartLink.name}" has been successfully created`,
      NOTIFICATION_STATUS.SUCCESS
    ));
    dispatch({
      type: CREATE_SMART_LINK_SUCCESS,
    });

    if (doWhenTry) {
      doWhenTry(smartLink.id);
    }
  } catch (e) {
    const {
      message,
      error,
    } = e?.response?.data || {};
    dispatch(addNotification(
      CREATE_SMART_LINK_ERROR,
      helpers.transform.toString(message || error || 'Server error'),
      NOTIFICATION_STATUS.ERROR
    ));
    dispatch({
      type: CREATE_SMART_LINK_ERROR,
    });

    if (doWhenCatch) {
      doWhenCatch(e);
    }
  }
};

export const updateSmartLink = (
  id,
  payload,
  doWhenTry = false,
  doWhenCatch = false
) => async (dispatch) => {
  try {
    dispatch({
      type: UPDATE_SMART_LINK,
    });
    const response = await axios.put(`/api/smart-links/${id}`, payload);
    const { smartLink } = response?.data || {};

    dispatch(addNotification(
      UPDATE_SMART_LINK_SUCCESS,
      'Smart link has been successfully updated',
      NOTIFICATION_STATUS.SUCCESS
    ));
    dispatch({
      type: UPDATE_SMART_LINK_SUCCESS,
      payload: smartLink,
    });

    if (doWhenTry) {
      doWhenTry(smartLink?.id);
    }
  } catch (e) {
    const {
      message,
      error,
    } = e?.response?.data || {};
    dispatch(addNotification(
      UPDATE_SMART_LINK_ERROR,
      helpers.transform.toString(message || error || 'Server error'),
      NOTIFICATION_STATUS.ERROR
    ));
    dispatch({
      type: UPDATE_SMART_LINK_ERROR,
    });

    if (doWhenCatch) {
      doWhenCatch(e);
    }
  }
};

export const deleteSmartLink = (
  id,
  doWhenTry = false,
  doWhenCatch = false
) => async (dispatch) => {
  dispatch({
    type: DELETE_SMART_LINK,
  });
  try {
    const response = await axios.delete(`/api/smart-links/${id}`);
    const isSuccess = response?.data?.success;

    if (!isSuccess) {
      dispatch(addNotification(
        DELETE_SMART_LINK_ERROR,
        'Cannot delete smart link',
        NOTIFICATION_STATUS.ERROR
      ));
      dispatch({
        type: DELETE_SMART_LINK_ERROR,
      });
      return;
    }

    dispatch(addNotification(
      DELETE_SMART_LINK_SUCCESS,
      'Smart link has been successfully deleted',
      NOTIFICATION_STATUS.SUCCESS
    ));
    dispatch({
      type: DELETE_SMART_LINK_SUCCESS,
    });

    if (doWhenTry) {
      doWhenTry();
    }
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(
      DELETE_SMART_LINK_ERROR,
      helpers.transform.toString(message || error || 'Server error'),
      NOTIFICATION_STATUS.ERROR
    ));
    dispatch({
      type: DELETE_SMART_LINK_ERROR,
    });

    if (doWhenCatch) {
      doWhenCatch(e);
    }
  }
};

// Same-user duplicate (CON-1549). Mirrors duplicateSmartForm: POST to the
// duplicate endpoint, notify, and hand the new link's id to doWhenTry so the
// caller can navigate to its edit screen.
export const duplicateSmartLink = (
  id,
  doWhenTry = false,
  doWhenCatch = false
) => async (dispatch) => {
  try {
    dispatch({
      type: DUPLICATE_SMART_LINK,
    });
    const response = await axios.post(`/api/smart-links/${id}/duplicate`);
    const { smartLink } = response?.data || {};

    if (!smartLink?.id) {
      dispatch(addNotification(
        DUPLICATE_SMART_LINK_ERROR,
        'Cannot duplicate smart link',
        NOTIFICATION_STATUS.ERROR
      ));
      dispatch({
        type: DUPLICATE_SMART_LINK_ERROR,
      });
      return;
    }

    dispatch(addNotification(
      DUPLICATE_SMART_LINK_SUCCESS,
      `Smart link "${smartLink.name}" has been successfully created`,
      NOTIFICATION_STATUS.SUCCESS
    ));
    dispatch({
      type: DUPLICATE_SMART_LINK_SUCCESS,
    });

    if (doWhenTry) {
      doWhenTry(smartLink.id);
    }
  } catch (e) {
    const {
      message,
      error,
    } = e?.response?.data || {};
    dispatch(addNotification(
      DUPLICATE_SMART_LINK_ERROR,
      helpers.transform.toString(message || error || 'Server error'),
      NOTIFICATION_STATUS.ERROR
    ));
    dispatch({
      type: DUPLICATE_SMART_LINK_ERROR,
    });

    if (doWhenCatch) {
      doWhenCatch(e);
    }
  }
};

// Cross-user verify (CON-1549). Posts the FLAT body shape { shareCode }
// (matches the BE verifyShareCode handler — intentionally different from
// apply's nested shape, mirroring Smart Forms). doWhenTry receives the
// owner/link-name payload; doWhenCatch receives the BE { error } message text
// so the component can show the real reason inline.
export const verifySmartLinkShareCode = (
  shareCode,
  doWhenTry = false,
  doWhenCatch = false
) => async (dispatch) => {
  try {
    dispatch({
      type: VERIFY_SMART_LINK_SHARE_CODE,
    });
    const response = await axios.post('/api/smart-links/verifyShareCode', { shareCode });
    const {
      smartLinkOwnerFirstName,
      smartLinkOwnerLastName,
      smartLinkName,
    } = response?.data || {};

    if (!smartLinkName) {
      dispatch({
        type: VERIFY_SMART_LINK_SHARE_CODE_ERROR,
      });
      if (doWhenCatch) {
        doWhenCatch('Invalid Share Code');
      }
      return;
    }

    dispatch({
      type: VERIFY_SMART_LINK_SHARE_CODE_SUCCESS,
    });

    if (doWhenTry) {
      doWhenTry({
        smartLinkOwnerFirstName,
        smartLinkOwnerLastName,
        smartLinkName,
      });
    }
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch({
      type: VERIFY_SMART_LINK_SHARE_CODE_ERROR,
    });
    if (doWhenCatch) {
      doWhenCatch(helpers.transform.toString(error || message || 'Invalid Share Code'));
    }
  }
};

// Cross-user apply (CON-1549). Posts the NESTED body shape
// { params: { shareCode } } (matches the BE applyShareCode handler — kept
// distinct from verify's flat shape, mirroring Smart Forms). doWhenTry
// receives { id, generatedName } of the new copy so the caller can navigate
// to its edit screen.
export const applySmartLinkShareCode = (
  shareCode,
  doWhenTry = false,
  doWhenCatch = false,
  // CON-2033 "Link your events": eventChoices go inside params only when
  // there are some; eventNames (keyed by sourcePartyId) name the user's
  // events in the success message.
  { eventChoices = undefined, eventNames = {} } = {}
) => async (dispatch) => {
  try {
    dispatch({
      type: APPLY_SMART_LINK_SHARE_CODE,
    });
    const params = {
      shareCode,
      ...(Array.isArray(eventChoices) && eventChoices.length ? { eventChoices } : {}),
    };
    const response = await axios.post('/api/smart-links/applyShareCode', { params });
    const {
      success,
      id,
      generatedName,
      eventLinks,
    } = response?.data || {};

    if (!success || !id) {
      dispatch(addNotification(
        APPLY_SMART_LINK_SHARE_CODE_ERROR,
        'Failed to import the smart link.',
        NOTIFICATION_STATUS.ERROR
      ));
      dispatch({
        type: APPLY_SMART_LINK_SHARE_CODE_ERROR,
      });
      return;
    }

    const eventLines = (eventLinks?.events || [])
      .map((event) => describeEventLinkOutcomeText(event, eventNames));
    dispatch(addNotification(
      APPLY_SMART_LINK_SHARE_CODE_SUCCESS,
      eventLines.length
        ? ['Successfully Applied the Share Code', ...eventLines]
          .map((line) => (/[.!?]$/.test(line) ? line : `${line}.`))
          .join(' ')
        : 'Successfully Applied the Share Code',
      NOTIFICATION_STATUS.SUCCESS
    ));
    dispatch({
      type: APPLY_SMART_LINK_SHARE_CODE_SUCCESS,
    });

    if (doWhenTry) {
      doWhenTry({ id, generatedName, eventLinks: eventLinks || null });
    }
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(
      APPLY_SMART_LINK_SHARE_CODE_ERROR,
      helpers.transform.toString(error || message || 'Server error'),
      NOTIFICATION_STATUS.ERROR
    ));
    dispatch({
      type: APPLY_SMART_LINK_SHARE_CODE_ERROR,
    });

    if (doWhenCatch) {
      doWhenCatch(e);
    }
  }
};

export const getSmartLinkClicks = (
  smartLinkId,
  options = {}
) => async (dispatch) => {
  dispatch({
    type: GET_SMART_LINK_CLICKS,
  });
  try {
    const {
      limit = 50, offset = 0, search = '', sortBy = '', sortOrder = '',
    } = options;
    const response = await axios.get(`/api/smart-links/${smartLinkId}/clicks`, {
      params: {
        limit, offset, search, sortBy, sortOrder,
      },
    });

    dispatch({
      type: GET_SMART_LINK_CLICKS_SUCCESS,
      payload: {
        clicks: response?.data?.clicks || [],
        total: response?.data?.total || 0,
      },
    });
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(
      GET_SMART_LINK_CLICKS_ERROR,
      helpers.transform.toString(message || error || 'Server error'),
      NOTIFICATION_STATUS.ERROR
    ));
    dispatch({
      type: GET_SMART_LINK_CLICKS_ERROR,
    });
  }
};

export const clearSmartLinks = () => async (dispatch) => {
  dispatch({
    type: CLEAR_SMART_LINKS,
  });
};

export const clearSmartLink = () => async (dispatch) => {
  dispatch({
    type: CLEAR_SMART_LINK,
  });
};

export const clearSmartLinkWasDeleted = () => async (dispatch) => {
  dispatch({
    type: CLEAR_SMART_LINK_WAS_DELETED,
  });
};

export const clearSmartLinkClicks = () => async (dispatch) => {
  dispatch({
    type: CLEAR_SMART_LINK_CLICKS,
  });
};

export const getActiveSmartLinks = () => async (dispatch) => {
  dispatch({
    type: GET_ACTIVE_SMART_LINKS,
  });
  try {
    const response = await axios.get('/api/smart-links', {
      params: { status: 'Active' },
    });
    dispatch({
      type: GET_ACTIVE_SMART_LINKS_SUCCESS,
      payload: response?.data?.smartLinks || [],
    });
  } catch (e) {
    dispatch({
      type: GET_ACTIVE_SMART_LINKS_ERROR,
    });
  }
};

export const clearActiveSmartLinks = () => ({
  type: CLEAR_ACTIVE_SMART_LINKS,
});
